import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          lang: "English",
          temple_360: "Temple360",
          home: "Home",
          services: "Services",
          login: "Log in",
          tutorial_360: "Tutorial 360",
          tap_to_know_more: "Tap to know more",
          home_intro_head: "A step towards your spiritual journey ",
          home_intro_subhead:
            "कामं क्रोधं च लोभं च यो जित्वा तीर्थमाविशेत्। न तेन किंचिदप्राप्तं तीर्थभिगमनाद् भवेत्।। ",
          home_intro_text:
            "Visit the 12 Jyotilingas and 4 Dhams of India from anywhere at anytime. A virtual pilgrimage experience that is a perfect alternative for those who are unable to leave their home or are just looking for a spiritual journey.",
          services_intro_head:
            "There is no well-wisher like charity and there is no bigger enemy than greediness in this world. There is no other ornament like character and there is no other money like satisfaction.",
          services_intro_subhead:
            "दानेन तुल्यं सुहृदास्ति नान्यो लोभाच्च नान्योऽस्ति रिपुः पृथिव्याम्।विभूषणं शीलसमं न चान्यत् सन्तोषतुल्यं धनमस्ति नान्यत्॥",
          about_head: "About",
          about_intro_head:
            "Temple 360 is an offering of the Ministry of Culture under the aegis of Azadi Ka Amrit Mahotsav commemorating 75 years of India’s independence. The start of the new year marks auspicious beginnings for all our new endeavours and hopes for the future. On this day we dedicate this website to the people of India and the world. Through this website, we hope to bring to you 24*7 the experience of immersive spiritual journeys and temple darshans through live camera feeds across the temples of India. In the near future the website will also enable you to avail various services such as ",
          watch: "Watch",
          share: "Share",
          back: "Back",
          coming_soon: "COMING SOON",
          back_to_home: "BACK TO HOME",
          diya_light_tribute: "Let’s welcome Nav Varsh by lighting a Deep",
          light_diya: "Light Deep",
          light_diya_again: "Light Another Deep",
          enter_name: "Enter your name here",
          e_prasad: "E-Prasad",

          e_aarti: "E-Arti",

          e_shringaar: "E-Sringaar",

          e_donation: "E-Donation",

          temple: "Temple",
          watchbutton: "Watch",
          cam_out: "Camera 1 - Outdoor",
          cam_in: "Camera 2 - Indoor",
          district: "District",
          state: "State",
          carousel: ["./imgservice/img0.jpg", "./imgservice/img1.jpg"],
          read_more: "Read more",
          read_less: "Read less",
          thankyou1: "Thank you for your participation! ",
          thankyou2: "Wish you a bright and lively future. ",
          // temp: [
          //   {
          //     id: 1,
          //     category: "jyotirlinga",
          //     key: "somnathtemple",
          //     title: "Somnath Temple",
          //     desc: "Believed to be the first among the twelve Jyotirlinga shrines of Shiva, the Somnath temple is located in Prabhas Patan. Somnath means “Lord of the Soma”, an epithet of Shiva. According to the legends, the temple was created by the Moon God himself.",
          //     district: "Gir Somnath District",
          //     state: "Gujarat",
          //     img_url: [
          //       "templeImg/Somnath/Somnath 1.jpg",
          //       "templeImg/Somnath/Somnath 2.jpg",
          //     ],
          //     vid: "beorNeGHLoc",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },

          //   {
          //     id: 2,
          //     category: "jyotirlinga",
          //     key: "trimbakeshwartemple",
          //     title: "Trimbakeshwar Temple",
          //     desc: "Trimbakeshwar is located in the city of Nashik. According to Shiva Mahapurana, on request of the Godavari and Gautam Rishi, Lord Shiva decided to reside here as Trimbakeshwar. It is considered to be a unique jyotirlinga: which has three faces symbolizing Lord Brahma, Lord Vishnu and Lord Shiva. The Jyotirlinga is covered by a jewelled crown, which is placed over the golden mask of the three gods.",
          //     district: " Nashik ",
          //     state: "Maharashtra",
          //     img_url: [
          //       "./templeImg/Trimbakeshwar/Trimbakeshwar 1.jpg",
          //       "./templeImg/Trimbakeshwar/Trimbakeshwar 2.jpg",
          //     ],
          //     vid: "eHMZeOPn3iw",
          //     notice:
          //       "Notice: Mandir Darshan Time will be from 07.00 AM to 08.00 PM.  The sanctum ('garbhagruha') door is closed for some time in morning, afternoon & evening puja for 'naivedya' offerings and after the aarti of Lord Shri Trimbakraja at night, the temple remains completely closed till the next morning",
          //     cam1: "https://www.youtube.com/watch?v=eHMZeOPn3iw&ab_channel=Trimbakeshwar",
          //     cam2: "https://www.youtube.com/watch?v=eHMZeOPn3iw&ab_channel=Trimbakeshwar",
          //   },
          //   {
          //     id: 3,
          //     category: "jyotirlinga",
          //     key: "ghrishneshwartemple",
          //     title: "Ghrishneshwar Temple",
          //     desc: "Grishneshwar Jyotirlinga temple is located in Aurangabad, Maharashtra. Touted to be the last or twelfth Jyotirlinga (pillar of light), Grishneshwar means the ‘lord of compassion’. The Grishneshwar Jyotirlinga temple is built of red rock and composed of a five-tier shikhara. It is also the smallest Jyotirlinga temple of Lord Shiva in India.",
          //     district: "Aurangabad",
          //     state: "Maharasthra",
          //     img_url: [
          //       "./templeImg/Grishneshwar/Grishneshwar 1.jpg",
          //       "./templeImg/Grishneshwar/Grishneshwar 2.jpg",
          //     ],
          //     vid: "ef8UPbREvwY",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },
          //   {
          //     id: 4,
          //     category: "jyotirlinga",
          //     key: "kashivishwanathtemple",
          //     title: "Kashi Vishwanath Temple ",
          //     desc: "Kashi Vishwanath Temple is located in Varanasi, Uttar Pradesh. Vishwanath means the Ruler of The Universe. On the occasion of Maha Shivaratri festival, the ghats are packed with Shiva devotees from all around the world. The temple has been built and re-built several times over the past few centuries.",
          //     district: "Varanasi",
          //     state: "Uttar Pradesh",
          //     img_url: [
          //       "./templeImg/KaishiVishwanath/KaishiVihswanath 1.jpg",
          //       "./templeImg/KaishiVishwanath/KaishiVihswanath 2.jpg",
          //     ],
          //     vid: "WGaC4kRoHHk",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },
          //   {
          //     id: 5,
          //     category: "jyotirlinga",
          //     key: "mahakaleshwartemple",
          //     title: "Mahakaleshwar Temple",
          //     district: "Khandwa",
          //     state: "Madhya Pradesh",
          //     desc: "Mahakaleshwar is situated in the ancient city of Ujjain in Madhya Pradesh. The idol of Mahakaleshwar is known to be dakshinamurti, which means that it is facing the south. One of the 12 Jyotirlingas in India, the lingam at the Mahakala is believed to be swayambhu (born of itself) deriving currents of power shakti from within itself. On occasion of Maha Shivratri, the Lord Shiva devotees worship whole night. A huge fair is also organized in the temple. ",
          //     img_url: [
          //       "/templeImg/Mahakaleshwar/Mahakaleshwar 1.jpg",
          //       "/templeImg/Mahakaleshwar/Mahakaleshwar 2.jpg",
          //     ],
          //     vid: "2ApM21OT4Mg",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },
          //   {
          //     id: 6,
          //     category: "dham",
          //     key: "dwarkadhishtemple",
          //     title: "Dwarkadhish Temple ",
          //     desc: "Dwarka is located in the western state of Gujarat. According to local beliefs, the Dwarkadhish Temple had been originally built by Lord Krishna's great grandson Vajranabha in honour of the Lord over 2,500 years ago. According to the temple administration, the original temple had an umbrella-like structure and an idol of Lord Krishna was placed there. Dwarkadhish temple, also known as the Jagat Mandir, is dedicated to Lord Krishna, who is worshipped here as Dwarkadhish, or 'King of Dwarka'. ",
          //     district: "Dwarka",
          //     state: "Gujarat",
          //     img_url: [
          //       "./templeImg/Dwarkadhish/Dwarkadhish 1.jpg",
          //       "./templeImg/Dwarkadhish/Dwarkadhish 2.jpg",
          //     ],
          //     vid: "jwl4CqpXk2Y",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },
          // ],
          service_data: [
            {
              id: 1,
              title: "E-Prasad",
              desc: "Make your offering.",
              img_url: "./imgservice/prasad.svg",
              page: "/prasad",
            },
            {
              id: 2,
              title: "E-Arti",
              desc: "Offer your prayers and book your slot.",
              img_url: "./imgservice/arti.svg",
              page: "/arti",
            },
            {
              id: 3,
              title: "E-Shringar",
              desc: "Make your offering to adorn the God. ",
              img_url: "./imgservice/shringar.svg",
              page: "/shringar",
            },
            {
              id: 4,
              title: "E-Donation",
              desc: "Donate for the temple.",
              img_url: "./imgservice/donation.svg",
              page: "/donation",
            },
          ],
          // data: [
          //   {
          //     category: "jyotirlinga",
          //     topic: "12 Jyotirlinga",
          //     homedesc:
          //       "The Indian saint Adi Shankaracharya who revived Sanatana Dharm in ancient period, has mentioned 12 most important Jyotirlingas in his Dwadasha Jyotirling Strotram situated in different locations of India.",
          //     desc: "Lord Shiva is revered as the Supreme God and Creator of the Universe. The Indian saint Adi Shankaracharya who revived Sanatana Dharm in ancient period...",
          //     description:
          //       " Lord Shiva is revered as the Supreme God and Creator of the Universe. The Indian saint Adi Shankaracharya who revived Sanatana Dharm in ancient period, has mentioned 12 most important Jyotirlingas in his Dwadasha Jyotirling Strotram situated in different locations of India. Visit these 12 Jyotilinga virtually through a 360 live Tour! According to legends, Lord Brahma and Vishnu went to combat a long time ago in order to establish dominance over the other. Shiva appeared in the form of a massive pillar of light in front of them. In order to find the ends of this radiant pillar, Brahma went upwards and Vishnu went downwards. Vishnu accepted defeat on not being able to find the end whereas Brahma chose to lie. Shiva emerged from the pillar and cursed Brahma that he won’t be worshipped till the end of eternity and blessed Vishnu for his piousness. This pillar of radiance is called ‘Jyotirling’.",

          //     content: [
          //       {
          //         id: 1,
          //         category: "jyotirlinga",
          //         key: "somnathtemple",
          //         title: "Somnath Temple",
          //         desc: "Believed to be the first among the twelve Jyotirlinga shrines of Shiva, the Somnath temple is located in Prabhas Patan. Somnath means “Lord of the Soma”, an epithet of Shiva. According to the legends, the temple was created by the Moon God himself.",
          //         district: "Gir Somnath District",
          //         state: "Gujarat",
          //         img_url: [
          //           "templeImg/Somnath/Somnath 1.jpg",
          //           "templeImg/Somnath/Somnath 2.jpg",
          //         ],
          //         vid: "beorNeGHLoc",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         e_donation_link:
          //           "https://somnath.org/Onlinedonation/HostedPaymentIndex",
          //         e_prasad_link: "http://somnathprasad.com",
          //       },
          //       {
          //         id: 2,
          //         category: "jyotirlinga",
          //         key: "mallikarjuntemple",
          //         title: "Mallikarjun Temple",
          //         desc: "Sri Bhramaramba Mallikarjuna Swamy Ammavarula Devasthanam is located at Srisailam, Kurnool district in Andhra Pradesh. Maha Shivaratri is the most important festival celebrated at Srisailam Mallikarjuna Swamy temple. According to the ancient scriptures, Shiva and Parvati stayed in Shrishailam, in order to remain close to his son Kartikey who had decided to stay alone on Mount Kravunja. Mallikarjuna Jyotirlinga is one of the 275 Paadal Petra Sthalams.",
          //         district: "Kurnool",
          //         state: "Andhra Pradesh",
          //         img_url: [
          //           "./templeImg/Mallikarjuna/Mallikarjuna 1.jpg",
          //           "./templeImg/Mallikarjuna/Mallikarjuna 2.jpg",
          //         ],
          //         vid: "rfyq-e9tvpw",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 3,
          //         category: "jyotirlinga",
          //         key: "mahakaleshwartemple",
          //         title: "Mahakaleshwar Temple",
          //         district: "Khandwa",
          //         state: "Madhya Pradesh",
          //         desc: "Mahakaleshwar is situated in the ancient city of Ujjain in Madhya Pradesh. The idol of Mahakaleshwar is known to be dakshinamurti, which means that it is facing the south. One of the 12 Jyotirlingas in India, the lingam at the Mahakala is believed to be swayambhu (born of itself) deriving currents of power shakti from within itself. On occasion of Maha Shivratri, the Lord Shiva devotees worship whole night. A huge fair is also organized in the temple. ",
          //         img_url: [
          //           "/templeImg/Mahakaleshwar/Mahakaleshwar 1.jpg",
          //           "/templeImg/Mahakaleshwar/Mahakaleshwar 2.jpg",
          //         ],
          //         vid: "2ApM21OT4Mg",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 4,
          //         category: "jyotirlinga",
          //         key: "omkareshwartemple",
          //         title: "Omkareshwar Temple",
          //         desc: "Omkareshwar is situated at Mandhata, an island in the Narmada River in Madhya Pradesh. The name “Omkareshwar” is based on the shape of the island, which appears to be Om. Omkareshwar means “Lord of Omkaara” or the “Lord of the Om Sound”.",
          //         district: "Khandwa",
          //         state: "Madhya Pradesh",
          //         img_url: [
          //           "./templeImg/Omkareshwar/Omkareshwar 1.jpg",
          //           "./templeImg/Omkareshwar/Omkareshwar 2.jpg",
          //         ],
          //         vid: "rdO8WEEnaeo",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 5,
          //         category: "jyotirlinga",
          //         key: "bababaidyanathtemple",
          //         title: "Baba Baidyanath Temple",
          //         desc: "Baba Baidyanath Temple is located in Deoghar, Jharkhand. The jyotirlinga got its name Vaidhya literally meaning ‘doctor’ from the believe that Lord Shiva cured his great worshipper, demon king, Ravana. Millions of pilgrims visit to attend Shraavana mela, and the Maha Shivratri is also the famous festival celebrated in the temple.",
          //         district: "Deogarh",
          //         state: "Jharkhand",
          //         img_url: [
          //           "./templeImg/Baidyanath/Baidyanath 1.jpg",
          //           "./templeImg/Baidyanath/Baidyanath 2.jpg",
          //         ],
          //         vid: "6olnAVtXw1o",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 6,
          //         category: "jyotirlinga",
          //         key: "bhimashankartemple",
          //         title: "Bhimashankar Temple",
          //         desc: "Bhimashankar Temple is located in Pune. It is situated at the source of River Bhima in the Bhimashankar hills in Khed Taluka. Built in the Nagara style of architecture, this temple dates back to the 18th century. According to the legend, it is believed that the ancient shrine was erected over a Swayambhu Linga or a Self Emanated Shiva Linga.",
          //         district: "Pune",
          //         state: "Maharashtra",
          //         img_url: [
          //           "./templeImg/Bhimashakar/Bhimashankar 1.jpg",
          //           "./templeImg/Bhimashakar/Bhimashankar 2.jpg",
          //         ],
          //         vid: "MI_IzBLJjyg",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 7,
          //         category: "jyotirlinga",
          //         key: "ramanathaswamytemple",
          //         title: "Ramanathaswamy Temple",
          //         desc: "Arulmigu Ramanathaswamy Temple is situated at the Rameswaram Island in Tamil Nadu. It is a Jyotilinga as well as one of the Char Dhams. According to the ancient Indian scriptures, the jyotirlingam was made by Lord Rama to seek Lord Shiva's blessings to attain victory over Ravana. It is believed that alike lingam is placed inside the sanctum. This Lingam worshipped by Lord Rama is known as Ramanathar. ",
          //         district: "Ramanathapuram",
          //         state: "Uttar Pradesh",
          //         img_url: [
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 1.jpg",
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 2.jpg",
          //         ],
          //         vid: "lanbHg9xRDc",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 8,
          //         category: "jyotirlinga",
          //         key: "nageshwartemple",
          //         title: "Nageshwar Temple",
          //         desc: "Nageshvara Jyotirlinga temple is located near Dwarka in Gujarat. According to the Shiva Mahapurana, Nageshvara Jyotirlinga is in ‘the Darukavana', an ancient name of a forest in India. The ancient Indian scriptures suggest that Lord Krishna used to perform Rudrabhishekam here.",
          //         district: "Gir Somnath District",
          //         state: "Gujarat",
          //         img_url: [
          //           "./templeImg/Nageshwara/Nageshwara 1.jpg",
          //           "./templeImg/Nageshwara/Nageshwara 2.jpg",
          //         ],
          //         vid: "DToE8Ysi-YA",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 9,
          //         category: "jyotirlinga",
          //         key: "kashivishwanathtemple",
          //         title: "Kashi Vishwanath Temple ",
          //         desc: "Kashi Vishwanath Temple is located in Varanasi, Uttar Pradesh. Vishwanath means the Ruler of The Universe. On the occasion of Maha Shivaratri festival, the ghats are packed with Shiva devotees from all around the world. The temple has been built and re-built several times over the past few centuries.",
          //         district: "Varanasi",
          //         state: "Uttar Pradesh",
          //         img_url: [
          //           "./templeImg/KaishiVishwanath/KaishiVihswanath 1.jpg",
          //           "./templeImg/KaishiVishwanath/KaishiVihswanath 2.jpg",
          //         ],
          //         vid: "WGaC4kRoHHk",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 10,
          //         category: "jyotirlinga",
          //         key: "trimbakeshwartemple",
          //         title: "Trimbakeshwar Temple",
          //         desc: "Trimbakeshwar is located in the city of Nashik. According to Shiva Mahapurana, on request of the Godavari and Gautam Rishi, Lord Shiva decided to reside here as Trimbakeshwar. It is considered to be a unique jyotirlinga: which has three faces symbolizing Lord Brahma, Lord Vishnu and Lord Shiva. The Jyotirlinga is covered by a jewelled crown, which is placed over the golden mask of the three gods.",
          //         district: " Nashik ",
          //         state: "Maharashtra",
          //         img_url: [
          //           "./templeImg/Trimbakeshwar/Trimbakeshwar 1.jpg",
          //           "./templeImg/Trimbakeshwar/Trimbakeshwar 2.jpg",
          //         ],
          //         vid: "gYzMYac_U7k",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         e_donation_link:
          //           "https://www.trimbakeshwartrust.com/donate.aspx",
          //       },
          //       {
          //         id: 11,
          //         category: "jyotirlinga",
          //         key: "kedarnathtemple",
          //         title: "Kedarnath Temple",
          //         desc: "Mahadev bhakts regard Kedarnath to be the most difficult Jyotilinga to visit. Kedarnath Temple, at 3,583 metres above sea level, experiences extreme climatic conditions. It is only open for six months of the year. It is believed that the temple was built by the Pandavas and revived by Adi Sankaracharya as one of the 275 Paadal Petra Sthalams.",
          //         district: "Rudraprayag",
          //         state: "Uttarakhand",
          //         img_url: [
          //           "./templeImg/Kedarnath/Kedarnath 1.jpg",
          //           "./templeImg/Kedarnath/Kedarnath 2.jpg",
          //         ],
          //         vid: "7sDeQenGn-A",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 12,
          //         category: "jyotirlinga",
          //         key: "ghrishneshwartemple",
          //         title: "Ghrishneshwar Temple",
          //         desc: "Grishneshwar Jyotirlinga temple is located in Aurangabad, Maharashtra. Touted to be the last or twelfth Jyotirlinga (pillar of light), Grishneshwar means the ‘lord of compassion’. The Grishneshwar Jyotirlinga temple is built of red rock and composed of a five-tier shikhara. It is also the smallest Jyotirlinga temple of Lord Shiva in India.",
          //         district: "Aurangabad",
          //         state: "Maharasthra",
          //         img_url: [
          //           "./templeImg/Grishneshwar/Grishneshwar 1.jpg",
          //           "./templeImg/Grishneshwar/Grishneshwar 2.jpg",
          //         ],
          //         vid: "ef8UPbREvwY",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //     ],
          //   },
          //   {
          //     category: "dham",
          //     topic: "4 Dham",
          //     homedesc:
          //       "Adi Shankacharya formed the Char Dham Yatra. It means ‘four abodes or seats of god’. It included four pious spots scattered in four directions of India - Dwarka (west), Badrinath (north), Puri (east) and Rameshwaram (south).",
          //     desc: "Adi Shankacharya formed the Char Dham Yatra. It means ‘four abodes or seats of god’. It included four pious spots scattered in four directions of India - Dwarka (west)...",

          //     description:
          //       "Adi Shankacharya formed the Char Dham Yatra. It means ‘four abodes or seats of god’. It included four pious spots scattered in four directions of India - Dwarka (west), Badrinath (north), Puri (east) and Rameshwaram (south). Yatra (or pilgrimage) in Hindu religion is considered as one of the ways of attaining Moksha. Visit these Char Dham virtually through a 360 live Tour! In Hinduism, the goals of an ideal life have been divided into four parts - Dharma (duty), Artha (wealth and prosperity), Kaam (worldly desires), Moksha (salvation or ultimate freedom).",
          //     content: [
          //       {
          //         id: 1,
          //         category: "dham",
          //         key: "dwarkadhishtemple",
          //         title: "Dwarkadhish Temple ",
          //         desc: "Dwarka is located in the western state of Gujarat. According to local beliefs, the Dwarkadhish Temple had been originally built by Lord Krishna's great grandson Vajranabha in honour of the Lord over 2,500 years ago. According to the temple administration, the original temple had an umbrella-like structure and an idol of Lord Krishna was placed there. Dwarkadhish temple, also known as the Jagat Mandir, is dedicated to Lord Krishna, who is worshipped here as Dwarkadhish, or 'King of Dwarka'. ",
          //         district: "Dwarka",
          //         state: "Gujarat",
          //         img_url: [
          //           "./templeImg/Dwarkadhish/Dwarkadhish 1.jpg",
          //           "./templeImg/Dwarkadhish/Dwarkadhish 2.jpg",
          //         ],
          //         vid: "jwl4CqpXk2Y",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 2,
          //         category: "dham",
          //         key: "jagannathatemple",
          //         title: "Jagannatha Temple",
          //         desc: "Shree Jagannath Temple is situated on the seashore of Puri, in Odisha. It was constructed in the 12th century by a famous king of Ganga Dynasty Ananta Varman Chodaganga Deva. The main temple of Jagannath is an impressive and amazing structure. It is an amazing example of Kalinga architecture, which was built at a height of 65 metres and placed on an elevated platform.",
          //         district: "Puri",
          //         state: "Odisha",
          //         img_url: [
          //           "./templeImg/Jagannatha/Jagannatha 1.jpg",
          //           "./templeImg/Jagannatha/Jagannatha 2.jpg",
          //         ],
          //         vid: "i_xYekU7Qqo",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 3,
          //         category: "dham",
          //         key: "bhadrinathtemple",
          //         title: "Bhadrinath Temple",
          //         desc: "Badrinath, or Badrinarayana Temple, is a Hindu temple dedicated to Lord Vishnu, situated in the town of Badrinath in Uttarakhand, India. Lord Vishnu is worshipped as Badrinath here. The temple is one of the 108 Divya Desams dedicated to Lord Vishnu.",
          //         district: "Chamoli",
          //         state: "Uttarakhand",
          //         img_url: [
          //           "./templeImg/Badrinath/Badrinath 1.jpg",
          //           "./templeImg/Badrinath/Badrinath 2.jpg",
          //         ],
          //         vid: "4xTpTOFYL-0",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 4,
          //         category: "dham",
          //         key: "ramanathaswamytemple",
          //         title: "Ramanathaswamy Temple",
          //         desc: "Arulmigu Ramanathaswamy Temple is situated at the Rameswaram Island in Tamil Nadu. It is a Jyotilinga as well as one of the Char Dhams. According to the ancient Indian scriptures, the jyotirlingam was made by Lord Rama to seek Lord Shiva's blessings to attain victory over Ravana. It is believed that alike lingam is placed inside the sanctum. This Lingam worshipped by Lord Rama is known as Ramanathar. ",
          //         district: "Ramanathapuram",
          //         state: "Uttar Pradesh",
          //         img_url: [
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 1.jpg",
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 2.jpg",
          //         ],
          //         vid: "lanbHg9xRDc",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //     ],
          //   },
          // ],
        },
      },
      hin: {
        translations: {
          lang: "hin",
          temple_360: "मंदिर 360",
          home: "होम",
          services: "सेवाएँ",
          login: "लॉग इन ",
          tutorial_360: "360 टूटोरीयल",
          tap_to_know_more: "अधिक जानकारी के लिए टैप करें",
          home_intro_head: "आध्यात्मिक यात्रा की दिशा में एक क़दम। ",
          home_intro_subhead:
            "कामं क्रोधं च लोभं च यो जित्वा तीर्थमाविशेत्। न तेन किंचिदप्राप्तं तीर्थभिगमनाद् भवेत्।। ",
          home_intro_text:
            "भारत के 12 ज्योतिर्लिंगों एवं 4 धामों की यात्रा करें, कहीं से भी, कभी भी। ऐसी वर्चूअल यात्रा का अनुभव करें, जो घर से निकलने में असमर्थ, अथवा केवल आध्यात्मिक यात्रा करने के इच्छुक लोगों के लिए बेहतरीन विकल्प है। ",
          services_intro_head:
            "दान के समान अन्य कोई सुहृद नहीं है और पृथ्वी पर लोभ के समान कोई शत्रु नहीं है। शील के समान कोई आभूषण नहीं है और संतोष के समान कोई धन नहीं है।",
          services_intro_subhead:
            "दानेन तुल्यं सुहृदास्ति नान्यो लोभाच्च नान्योऽस्ति रिपुः पृथिव्याम्।विभूषणं शीलसमं न चान्यत् सन्तोषतुल्यं धनमस्ति नान्यत्॥",
          about_head: "विषय में",

          about_intro_head:
            "भारत की स्वतंत्रता के 75 साल पूरे होने के उपलक्ष्य में आज़ादी का अमृत महोत्सव के तत्वावधान में संस्कृति मंत्रालय की एक अनमोल भेंट है, टेंपल 360नव वर्ष का आरंभ हमारे सभी नए प्रयासों एवं भविष्य की आशाओं के लिए शुभारंभ का प्रतीक है। इस शुभ अवसर पर हम यह वेबसाइट भारत और दुनिया के लोगों को समर्पित कर रहे हैं। इस वेबसाइट के माध्यम से आपके लिए भारत के विभिन्न मंदिरों के लाइव कैमरा फीड प्रतिदिन, प्रतिपल प्रस्तुत करने का प्रयास किया गया है जहाँ भारत के मंदिरों की अमर आध्यात्मिक यात्रा और मंदिर दर्शन का सजीव अनुभव मिलता है।  निकट भविष्य में वेबसाइट पर विभिन्न सेवाएँ भी उपलब्ध होंगी, जैसे - ",
          watch: "दर्शन करें ",
          share: "साझा करें ",
          back: "पीछे जाएँ ",
          coming_soon: "जल्द आ रहा है",
          back_to_home: "होम पर जाएँ ",
          diya_light_tribute: "आइए एक दीप जलाकर नव वर्ष का स्वागत करें",
          light_diya: "दीया जलाएं",
          light_diya_again: "एक और दिया जलाये",
          enter_name: "अपना नाम दर्ज करें",
          e_prasad: "ई-प्रसाद",

          e_aarti: "ई-आरती",

          e_shringaar: "ई-शृंगार",

          e_donation: "ई-दान ",

          temple: "मंदिर",
          watchbutton: "दर्शन",
          cam_out: "कैमरा 1 - आउटडोर ",
          cam_in: "कैमरा 2 - इंडोर ",
          district: "ज़िला",
          state: "राज्य",
          carousel: ["./imgservice/img2.jpg", "./imgservice/img1.jpg"],
          read_more: "अधिक पढ़ें",
          read_less: "संक्षेप में पढ़ें",
          thankyou1: "आपकी भागीदारी के लिए आभार। ",
          thankyou2: "आपके उज्ज्वल और सुखमय भविष्य की कामना है ।",
          // temp: [
          //   {
          //     id: 1,
          //     category: "jyotirlinga",
          //     key: "somnathtemple",
          //     title: "सोमनाथ मंदिर",
          //     desc: "भगवान शिव के बारह ज्योतिर्लिंगों में से पहला माना जाने वाला सोमनाथ मंदिर प्रभास पाटन में स्थित है। सोमनाथ का अर्थ है, 'सोम - अर्थात्, चंद्र देव के भगवान', जिन्हें महादेव शिव का विशेषण माना जाता है। मान्यता है कि इस मंदिर का निर्माण स्वयं चंद्रदेव ने करवाया था।",
          //     district: " गिर सोमनाथ ज़िला ",
          //     state: " गुजरात ",
          //     img_url: [
          //       "templeImg/Somnath/Somnath 1.jpg",
          //       "templeImg/Somnath/Somnath 2.jpg",
          //     ],
          //     vid: "beorNeGHLoc",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },

          //   {
          //     id: 2,
          //     category: "jyotirlinga",
          //     key: "trimbakeshwartemple",
          //     title: "त्र्यंबकेश्वर मंदिर",
          //     desc: "त्र्यंबकेश्वर ज्योतिर्लिंग नासिक शहर में स्थित है। शिव महापुराण में वर्णन मिलता है कि गोदावरी एवं गौतम ऋषि के निवेदन पर महादेव शिव ने यहाँ अपने त्र्यंबकेश्वर रूप में वास करने का निर्णय लिया। इसे एक विशिष्ट ज्योतिर्लिंग माना जाता है, जिसके तीन मुख ब्रह्मदेव, भगवान विष्णु एवं भगवान शिव के प्रतीक हैं। ज्योतिर्लिंग के ऊपर अलंकृत मुकुट सुसज्जित है, जो त्रिदेवों के स्वर्णिम आवरण के ऊपर स्थापित है। ",
          //     district: " नासिक ",
          //     state: "महाराष्ट्र",
          //     img_url: [
          //       "./templeImg/Trimbakeshwar/Trimbakeshwar 1.jpg",
          //       "./templeImg/Trimbakeshwar/Trimbakeshwar 2.jpg",
          //     ],
          //     vid: "gYzMYac_U7k",
          //     notice:
          //       "नोटीस: मंदिर दर्शन के लिये हर दिन सुबह ०७.०० ते शाम ०८.०० बजे तक खुला रहेगा.मंदिर का मुख्य गर्भगृह द्वार सुबह, दोपहर और श्याम के प्रसाद-भोग के लिये कुछ समय बंद रहता है| तथा रात में श्री त्र्यंबकराज की आरती के बाद, अगले दिनसुबह तक मंदिर पूरी तरह से बंद रहता है।",
          //     cam1: "https://www.youtube.com/watch?v=eHMZeOPn3iw&ab_channel=Trimbakeshwar",
          //     cam2: "https://www.youtube.com/watch?v=eHMZeOPn3iw&ab_channel=Trimbakeshwar",
          //   },
          //   {
          //     id: 3,
          //     category: "jyotirlinga",
          //     key: "ghrishneshwartemple",
          //     title: "घृष्णेश्वर मंदिर",
          //     desc: "घृष्णेश्वर ज्योतिर्लिंग मंदिर महाराष्ट्र के औरंगाबाद में स्थित है। अंतिम या बारहवें ज्योतिर्लिंग (प्रकाश स्तंभ) के रूप में प्रसिद्ध 'घृष्णेश्वर' का अर्थ है 'करुणा का स्वामी'। घृष्णेश्वर ज्योतिर्लिंग मंदिर लाल चट्टान से निर्मित है, जिसमें पाँच स्तरीय शिखर बने हैं। यह भारत में भगवान शिव का सबसे छोटा ज्योतिर्लिंग मंदिर भी है। पूरे भारत में यह भगवान शिव का सबसे छोटा ज्योतिर्लिंग मंदिर है। ",
          //     district: "औरंगाबाद",
          //     state: "महाराष्ट्र",
          //     img_url: [
          //       "./templeImg/Grishneshwar/Grishneshwar 1.jpg",
          //       "./templeImg/Grishneshwar/Grishneshwar 2.jpg",
          //     ],
          //     vid: "ef8UPbREvwY",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },
          //   {
          //     id: 4,
          //     category: "jyotirlinga",
          //     key: "kashivishwanathtemple",
          //     title: "काशी विश्वनाथ मंदिर ",
          //     desc: "काशी विश्वनाथ मंदिर उत्तर प्रदेश के वाराणसी में स्थित है। विश्वनाथ का अर्थ है, पूरे ब्रह्मांड के स्वामी। महाशिवरात्रि पर्व के अवसर पर वाराणसी के घाटों पर पूरे विश्व से आए भक्तों की भीड़ जमा होती है। पिछली अनेक शताब्दियों से मंदिर का अनेक बार निर्माण एवं पुनर्निर्माण हुआ है। ",
          //     district: "वाराणसी",
          //     state: "उत्तर प्रदेश",
          //     img_url: [
          //       "./templeImg/KaishiVishwanath/KaishiVihswanath 1.jpg",
          //       "./templeImg/KaishiVishwanath/KaishiVihswanath 2.jpg",
          //     ],
          //     vid: "WGaC4kRoHHk",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },

          //   {
          //     id: 5,
          //     category: "jyotirlinga",
          //     key: "mahakaleshwartemple",
          //     title: "महाकालेश्वर मंदिर",
          //     district: "खंडवा",
          //     state: "मध्य प्रदेश",
          //     desc: "मध्य प्रदेश के प्राचीन उज्जैन शहर में महाकालेश्वर ज्योतिर्लिंग स्थित है। महाकालेश्वर की मूर्ति को दक्षिणामूर्ति कहते हैं, जिसका अर्थ है कि इसका मुख दक्षिण दिशा की ओर है। 12 ज्योतिर्लिंगों में से एक महाकालेश्वर ज्योतिर्लिंग को स्वयंभू माना जाता है, अर्थात् स्वयं उत्पन्न हुआ है, जो अपने भीतर से शक्ति को उत्पन्न करके प्रकट हुआ है। महाशिवरात्रि के अवसर पर महादेव शिव के भक्त पूरी रात शिव का पूजन करते हैं। साथ ही, मंदिर में एक विशाल मेले का आयोजन होता है। ",
          //     img_url: [
          //       "/templeImg/Mahakaleshwar/Mahakaleshwar 1.jpg",
          //       "/templeImg/Mahakaleshwar/Mahakaleshwar 2.jpg",
          //     ],
          //     vid: "2ApM21OT4Mg",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },
          //   {
          //     id: 6,
          //     category: "dham",
          //     key: "dwarkadhishtemple",
          //     title: "द्वारकाधीश मंदिर",
          //     desc: "द्वारका देश के पश्चिमी राज्य गुजरात में स्थित है। स्थानीय मान्यताओं के अनुसार द्वारकाधीश मंदिर का निर्माण मूल रूप से भगवान कृष्ण के परपोते वज्रनाभ ने 2,500 से भी अधिक वर्ष पहले भगवान के सम्मान में किया था। मंदिर प्रशासन के अनुसार, मूल मंदिर में एक छत्र जैसी संरचना थी, जहाँ भगवान कृष्ण की मूर्ति स्थापित थी। जगत मंदिर के नाम से भी प्रसिद्ध द्वारकाधीश मंदिर भगवान कृष्ण को समर्पित है, जिन्हें यहाँ द्वारकाधीश या 'द्वारका के राजा' के रूप में पूजा जाता है।",
          //     district: "द्वारिका",
          //     state: "गुजरात",
          //     img_url: [
          //       "./templeImg/Dwarkadhish/Dwarkadhish 1.jpg",
          //       "./templeImg/Dwarkadhish/Dwarkadhish 2.jpg",
          //     ],
          //     vid: "jwl4CqpXk2Y",
          //     cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //     cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //   },
          // ],
          service_data: [
            {
              id: 1,
              title: "ई-प्रसाद",
              desc: "प्रसाद चढ़ाएँ",
              img_url: "./imgservice/prasad.svg",
              page: "/prasad",
            },
            {
              id: 2,
              title: "ई-आरती",
              desc: "पूजन करें और अपने लिए समय बुक करें.",
              img_url: "./imgservice/arti.svg",
              page: "/arti",
            },
            {
              id: 3,
              title: "ई-शृंगार",
              desc: "भगवान का अलंकरण करें  ",
              img_url: "./imgservice/shringar.svg",
              page: "/shringar",
            },
            {
              id: 4,
              title: "ई-दान",
              desc: "मंदिर के लिए दान दें",
              img_url: "./imgservice/donation.svg",
              page: "/donation",
            },
          ],
          // data: [
          //   {
          //     category: "jyotirlinga",
          //     topic: "12 ज्योतिर्लिंग",
          //     homedesc:
          //       " सनातन धर्म में नव-जागरण करने वाले जगद्गुरु आदि शंकरचार्य ने अपने द्वादश ज्योतिर्लिंग स्तोत्र में 12 सर्वाधिक महत्त्वपूर्ण ज्योतिर्लिंगों का वर्णन किया है, जो भारत के अलग-अलग स्थानों पर स्थित हैं।",
          //     description:
          //       " महादेव शिव को संपूर्ण ब्रह्मांड में सर्वोच्च स्थान पर आसीन माना जाता है, जिन्हें सृष्टि का निर्माता भी माना जाता है। सनातन धर्म में नव-जागरण करने वाले जगद्गुरु आदि शंकरचार्य ने अपने द्वादश ज्योतिर्लिंग स्तोत्र में 12 सर्वाधिक महत्त्वपूर्ण ज्योतिर्लिंगों का वर्णन किया है, जो भारत के अलग-अलग स्थानों पर स्थित हैं। 360 लाइव यात्रा के माध्यम से इन 12 ज्योतिर्लिंगों की वर्चूअल यात्रा करें! शिव महापुराण के अनुसार, एक बार भगवान ब्रह्मा और विष्णु सृष्टि की सर्वोच्च शक्ति के सत्य को खोजने का प्रयास कर रहे थे। उनकी चर्चा के बीच उनके सामने एक विशाल प्रकाश स्तंभ के रूप में महादेव शिव प्रकट हुए। उस प्रकाशमय स्तंभ के सिरों को ढूँढने के लिए ब्रह्मा जी ऊपर की ओर उड़कर गए और विष्णु जी नीचे की ओर गए। लेकिन दोनों में से किसी को भी उस अनंत प्रकाशमय स्तंभ का सिरा नहीं मिला। सर्वव्यापी, महेश्वर का प्रतीक यह अनंत प्रकाशमय स्तंभ 'ज्योतिर्लिंग' कहलाता है।  ",
          //     desc: "महादेव शिव को संपूर्ण ब्रह्मांड में सर्वोच्च स्थान पर आसीन माना जाता है, जिन्हें सृष्टि का निर्माता भी माना जाता है। सनातन धर्म में नव-जागरण करने वाले जगद्गुरु आदि शंकरचार्य ...",
          //     content: [
          //       {
          //         id: 1,
          //         category: "jyotirlinga",
          //         key: "somnathtemple",
          //         title: "सोमनाथ मंदिर",
          //         desc: "भगवान शिव के बारह ज्योतिर्लिंगों में से पहला माना जाने वाला सोमनाथ मंदिर प्रभास पाटन में स्थित है। सोमनाथ का अर्थ है, 'सोम - अर्थात्, चंद्र देव के भगवान', जिन्हें महादेव शिव का विशेषण माना जाता है। मान्यता है कि इस मंदिर का निर्माण स्वयं चंद्रदेव ने करवाया था।",
          //         district: " गिर सोमनाथ ज़िला ",
          //         state: " गुजरात ",
          //         img_url: [
          //           "templeImg/Somnath/Somnath 1.jpg",
          //           "templeImg/Somnath/Somnath 2.jpg",
          //         ],
          //         vid: "beorNeGHLoc",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         e_donation_link:
          //           "https://somnath.org/Onlinedonation/HostedPaymentIndex",
          //         e_prasad_link: "http://somnathprasad.com",
          //       },
          //       {
          //         id: 2,
          //         category: "jyotirlinga",
          //         key: "mallikarjuntemple",
          //         title: "मल्लिकार्जुन मंदिर",
          //         desc: "श्री भ्रामराम्बा मल्लिकार्जुन स्वामी अम्मावरुला देवस्थानम आंध्र प्रदेश के श्रीशैलम में स्थित है। श्रीशैलम मल्लिकार्जुन स्वामी मंदिर में मनाया जाने वाला सबसे महत्त्वपूर्ण पर्व महा शिवरात्रि का होता है। प्राचीन शास्त्रों में कहा गया है कि भगवान शिव एवं माँ पार्वती ने अपने पुत्र कार्तिकेय के निकट रहने के लिए श्रीशैलम में शिवलिंग के रूप में वास किया, जो क्रवुंज पर्वत पर अकेले वास करने के लिए गए थे। मल्लिकार्जुन ज्योतिर्लिंग 275 पाडल पेट्रा स्थलम में से एक है। ",
          //         district: "कुरनूल",
          //         state: "आंध्र प्रदेश ",
          //         img_url: [
          //           "./templeImg/Mallikarjuna/Mallikarjuna 1.jpg",
          //           "./templeImg/Mallikarjuna/Mallikarjuna 2.jpg",
          //         ],
          //         vid: "rfyq-e9tvpw",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 3,
          //         category: "jyotirlinga",
          //         key: "mahakaleshwartemple",
          //         title: "महाकालेश्वर मंदिर",
          //         district: "खंडवा",
          //         state: "मध्य प्रदेश",
          //         desc: "मध्य प्रदेश के प्राचीन उज्जैन शहर में महाकालेश्वर ज्योतिर्लिंग स्थित है। महाकालेश्वर की मूर्ति को दक्षिणामूर्ति कहते हैं, जिसका अर्थ है कि इसका मुख दक्षिण दिशा की ओर है। 12 ज्योतिर्लिंगों में से एक महाकालेश्वर ज्योतिर्लिंग को स्वयंभू माना जाता है, अर्थात् स्वयं उत्पन्न हुआ है, जो अपने भीतर से शक्ति को उत्पन्न करके प्रकट हुआ है। महाशिवरात्रि के अवसर पर महादेव शिव के भक्त पूरी रात शिव का पूजन करते हैं। साथ ही, मंदिर में एक विशाल मेले का आयोजन होता है। ",
          //         img_url: [
          //           "/templeImg/Mahakaleshwar/Mahakaleshwar 1.jpg",
          //           "/templeImg/Mahakaleshwar/Mahakaleshwar 2.jpg",
          //         ],
          //         vid: "2ApM21OT4Mg",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 4,
          //         category: "jyotirlinga",
          //         key: "omkareshwartemple",
          //         title: "ॐकारेश्वर मंदिर",
          //         desc: "मध्य प्रदेश में नर्मदा नदी पर स्थित मांधाता टापू पर ॐकारेश्वर ज्योतिर्लिंग स्थित है। इस टापू का आकार 'ॐकार' के आकार का है, जिसके कारण इसका नाम 'ॐकारेश्वर' पड़ा। ॐकारेश्वर का अर्थ है 'ॐकार के ईश्वर' अथवा 'ॐ ध्वनि के स्वामी'। ",
          //         district: "खंडवा",
          //         state: "मध्य प्रदेश",
          //         img_url: [
          //           "./templeImg/Omkareshwar/Omkareshwar 1.jpg",
          //           "./templeImg/Omkareshwar/Omkareshwar 2.jpg",
          //         ],
          //         vid: "rdO8WEEnaeo",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 5,
          //         category: "jyotirlinga",
          //         key: "bababaidyanathtemple",
          //         title: "बाबा बैद्यनाथ मंदिर",
          //         desc: "बाबा बैद्यनाथ मंदिर देवघर, झारखंड में स्थित है। वैद्यनाथ ज्योतिर्लिंग नाम का शाब्दिक अर्थ 'चिकित्सक' है। इस विषय में धारणा है कि भगवान शिव ने अपने श्रेष्ठ उपासक राक्षस राजा रावण को स्वस्थ किया था। यहाँ श्रावण मेले में भाग लेने के लिए लाखों तीर्थयात्री आते हैं। साथ ही, यहाँ महाशिवरात्रि का प्रसिद्ध पर्व भी मनाया जाता है।",
          //         district: "देवगढ़",
          //         state: "झारखंड",
          //         img_url: [
          //           "./templeImg/Baidyanath/Baidyanath 1.jpg",
          //           "./templeImg/Baidyanath/Baidyanath 2.jpg",
          //         ],
          //         vid: "6olnAVtXw1o",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 6,
          //         category: "jyotirlinga",
          //         key: "bhimashankartemple",
          //         title: "भीमाशंकर मंदिर",
          //         desc: "भीमाशंकर मंदिर पुणे में स्थित है। यह खेड़ तालुका में भीमाशंकर पहाड़ियों में भीमा नदी के स्रोत पर स्थित है। नागरा शैली की स्थापत्य कला में निर्मित यह मंदिर 18वीं शताब्दी में बनाया गया था। प्राचीन कथाओं के आधार पर मान्यता है कि स्वयंभू लिंग अर्थात् स्वयं-प्रकट हुए शिवलिंग पर ही प्राचीन मंदिर का निर्माण हुआ। ",
          //         district: "पुणे",
          //         state: "महाराष्ट्र",
          //         img_url: [
          //           "./templeImg/Bhimashakar/Bhimashankar 1.jpg",
          //           "./templeImg/Bhimashakar/Bhimashankar 2.jpg",
          //         ],
          //         vid: "MI_IzBLJjyg",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 7,
          //         category: "jyotirlinga",
          //         key: "ramanathaswamytemple",
          //         title: "रामनाथस्वामी मंदिर",
          //         desc: "अरुलमिगु रामनाथस्वामी मंदिर तमिलनाडु के रामेश्वरम द्वीप पर स्थित है। यह ज्योतिर्लिंग होने के साथ ही चार धामों में से भी एक है। प्राचीन भारतीय शास्त्रों के अनुसार रावण पर विजय प्राप्त करने के लिए भगवान शिव का आशीर्वाद लेने के उद्देश्य से स्वयं भगवान राम ने इस ज्योतिर्लिंगम का निर्माण किया था। माना जाता है कि मंदिर के गर्भगृह में ऐसा ही एक लिंगम स्थापित है। भगवान राम ने जिस लिंगम की आराधना की थी वह रामनाथर के नाम से प्रसिद्ध है। ",
          //         district: "रामनाथापुरम",
          //         state: " उत्तर प्रदेश ",
          //         img_url: [
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 1.jpg",
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 2.jpg",
          //         ],
          //         vid: "lanbHg9xRDc",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 8,
          //         category: "jyotirlinga",
          //         key: "nageshwartemple",
          //         title: "नागेश्वर मंदिर",
          //         desc: "नागेश्वर ज्योतिर्लिंग गुजरात में द्वारिका के निकट स्थित है। शिव महापुराण में कहा गया है कि नागेश्वर ज्योतिर्लिंग 'दारुकवन' में स्थित है, जो प्राचीन भारत में वनों को कहा जाता था। प्राचीन भारतीय शास्त्रों के अनुसार भगवान कृष्ण यहीं रुद्राभिषेक करते थे।  ",
          //         district: "गिर सोमनाथ ज़िला ",
          //         state: "गुजरात",
          //         img_url: [
          //           "./templeImg/Nageshwara/Nageshwara 1.jpg",
          //           "./templeImg/Nageshwara/Nageshwara 2.jpg",
          //         ],
          //         vid: "DToE8Ysi-YA",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 9,
          //         category: "jyotirlinga",
          //         key: "kashivishwanathtemple",
          //         title: "काशी विश्वनाथ मंदिर ",
          //         desc: "काशी विश्वनाथ मंदिर उत्तर प्रदेश के वाराणसी में स्थित है। विश्वनाथ का अर्थ है, पूरे ब्रह्मांड के स्वामी। महाशिवरात्रि पर्व के अवसर पर वाराणसी के घाटों पर पूरे विश्व से आए भक्तों की भीड़ जमा होती है। पिछली अनेक शताब्दियों से मंदिर का अनेक बार निर्माण एवं पुनर्निर्माण हुआ है। ",
          //         district: "वाराणसी",
          //         state: "उत्तर प्रदेश",
          //         img_url: [
          //           "./templeImg/KaishiVishwanath/KaishiVihswanath 1.jpg",
          //           "./templeImg/KaishiVishwanath/KaishiVihswanath 2.jpg",
          //         ],
          //         vid: "WGaC4kRoHHk",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 10,
          //         category: "jyotirlinga",
          //         key: "trimbakeshwartemple",
          //         title: "त्र्यंबकेश्वर मंदिर",
          //         desc: "त्र्यंबकेश्वर ज्योतिर्लिंग नासिक शहर में स्थित है। शिव महापुराण में वर्णन मिलता है कि गोदावरी एवं गौतम ऋषि के निवेदन पर महादेव शिव ने यहाँ अपने त्र्यंबकेश्वर रूप में वास करने का निर्णय लिया। इसे एक विशिष्ट ज्योतिर्लिंग माना जाता है, जिसके तीन मुख ब्रह्मदेव, भगवान विष्णु एवं भगवान शिव के प्रतीक हैं। ज्योतिर्लिंग के ऊपर अलंकृत मुकुट सुसज्जित है, जो त्रिदेवों के स्वर्णिम आवरण के ऊपर स्थापित है। ",
          //         district: " नासिक ",
          //         state: "महाराष्ट्र",
          //         img_url: [
          //           "./templeImg/Trimbakeshwar/Trimbakeshwar 1.jpg",
          //           "./templeImg/Trimbakeshwar/Trimbakeshwar 2.jpg",
          //         ],
          //         vid: "gYzMYac_U7k",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         e_donation_link:
          //           "https://www.trimbakeshwartrust.com/donate.aspx",
          //       },
          //       {
          //         id: 11,
          //         category: "jyotirlinga",
          //         key: "kedarnathtemple",
          //         title: "केदारनाथ मंदिर",
          //         desc: "महादेव के भक्तों का मानना है कि केदारनाथ ज्योतिर्लिंग का दर्शन अन्य सभी ज्योतिर्लिंगों के दर्शन की तुलना में अधिक कठिन है। समुद्र तल से 3,583 मीटर की ऊँचाई पर स्थित केदारनाथ मंदिर में मौसम की चरम स्थितियाँ पाई जाती हैं। यह साल के केवल छः महीने ही खुला रहता है। माना जाता है कि इस मंदिर का निर्माण पांडवों ने किया था और आदि शंकराचार्य ने 275 पाडल पेट्रा स्थलम में से एक मंदिर के रूप में इसका जीर्णोद्धार किया। ",
          //         district: "रुद्रप्रयाग",
          //         state: "उत्तराखंड",
          //         img_url: [
          //           "./templeImg/Kedarnath/Kedarnath 1.jpg",
          //           "./templeImg/Kedarnath/Kedarnath 2.jpg",
          //         ],
          //         vid: "7sDeQenGn-A",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 12,
          //         category: "jyotirlinga",
          //         key: "ghrishneshwartemple",
          //         title: "घृष्णेश्वर मंदिर",
          //         desc: "घृष्णेश्वर ज्योतिर्लिंग मंदिर महाराष्ट्र के औरंगाबाद में स्थित है। अंतिम या बारहवें ज्योतिर्लिंग (प्रकाश स्तंभ) के रूप में प्रसिद्ध 'घृष्णेश्वर' का अर्थ है 'करुणा का स्वामी'। घृष्णेश्वर ज्योतिर्लिंग मंदिर लाल चट्टान से निर्मित है, जिसमें पाँच स्तरीय शिखर बने हैं। यह भारत में भगवान शिव का सबसे छोटा ज्योतिर्लिंग मंदिर भी है। पूरे भारत में यह भगवान शिव का सबसे छोटा ज्योतिर्लिंग मंदिर है। ",
          //         district: "औरंगाबाद",
          //         state: "महाराष्ट्र",
          //         img_url: [
          //           "./templeImg/Grishneshwar/Grishneshwar 1.jpg",
          //           "./templeImg/Grishneshwar/Grishneshwar 2.jpg",
          //         ],
          //         vid: "ef8UPbREvwY",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //     ],
          //   },
          //   {
          //     category: "dham",
          //     topic: "चार धाम",
          //     homedesc:
          //       "आदि शंकराचार्य ने भारत की चार दिशाओं में चार महत्त्वपूर्ण मंदिरों की स्थापना की, जो चार-धाम के नाम से प्रसिद्ध हुए। इन चारों मंदिरों की यात्रा 'चार-धाम यात्रा' कहलाती है।",
          //     description:
          //       "आदि शंकराचार्य ने भारत की चार दिशाओं में चार महत्त्वपूर्ण मंदिरों की स्थापना की, जो चार-धाम के नाम से प्रसिद्ध हुए। इन चारों मंदिरों की यात्रा 'चार-धाम यात्रा' कहलाती है। इसका अर्थ है 'ईश्वर के चार निवास या पीठ।' ये चार पवित्र-स्थल भारत की चार दिशाओं पर स्थित हैं - बद्रीनाथ (उत्तर), पुरी (पूर्व), रामेश्वरम (दक्षिण) एवं द्वारिका (पश्चिम)। सनातन धर्म में तीर्थ यात्रा को मोक्ष प्राप्त करने का एक माध्यम माना जाता है। 360 लाइव यात्रा के द्वारा चारों धाम के वर्चूअल दर्शन करें! सनातन धर्म में, आदर्श मानव जीवन के लक्ष्यों को चार भागों विभाजित किया गया है - धर्म (कर्तव्य), अर्थ (धन एवं संपत्ति), काम (भौतिक सुख) एवं मोक्ष (जन्म-मृत्यु के चक्र से मुक्ति)। इनमें मोक्ष को मानव-जीवन का सर्वोच्च उद्देश्य माना गया है। ",
          //     desc: "आदि शंकराचार्य ने भारत की चार दिशाओं में चार महत्त्वपूर्ण मंदिरों की स्थापना की, जो चार-धाम के नाम से प्रसिद्ध हुए। इन चारों मंदिरों की यात्रा 'चार-धाम यात्रा' कहलाती है...",

          //     content: [
          //       {
          //         id: 1,
          //         category: "dham",
          //         key: "dwarkadhishtemple",
          //         title: "द्वारकाधीश मंदिर",
          //         desc: "द्वारका देश के पश्चिमी राज्य गुजरात में स्थित है। स्थानीय मान्यताओं के अनुसार द्वारकाधीश मंदिर का निर्माण मूल रूप से भगवान कृष्ण के परपोते वज्रनाभ ने 2,500 से भी अधिक वर्ष पहले भगवान के सम्मान में किया था। मंदिर प्रशासन के अनुसार, मूल मंदिर में एक छत्र जैसी संरचना थी, जहाँ भगवान कृष्ण की मूर्ति स्थापित थी। जगत मंदिर के नाम से भी प्रसिद्ध द्वारकाधीश मंदिर भगवान कृष्ण को समर्पित है, जिन्हें यहाँ द्वारकाधीश या 'द्वारका के राजा' के रूप में पूजा जाता है।",
          //         district: "द्वारिका",
          //         state: "गुजरात",
          //         img_url: [
          //           "./templeImg/Dwarkadhish/Dwarkadhish 1.jpg",
          //           "./templeImg/Dwarkadhish/Dwarkadhish 2.jpg",
          //         ],
          //         vid: "jwl4CqpXk2Y",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 2,
          //         category: "dham",
          //         key: "jagannathatemple",
          //         title: "जगन्नाथ मंदिर",
          //         desc: "श्री जगन्नाथ मंदिर ओडिशा में पुरी के समुद्र तट पर स्थित है। इसका निर्माण 12 वीं शताब्दी में गंगा राजवंश के प्रसिद्ध राजा अनंत वर्मन चोदगंगा देव ने करवाया था। जगन्नाथ के मुख्य मंदिर की संरचना अत्यधिक आकर्षक एवं अद्भुत है। यह कलिंग वास्तुकला का एक उत्कृष्ट उदाहरण है, जिसे 65 मीटर की ऊँचाई पर बनाया गया था और एक ऊँचे स्थापित किया गया गया था।",
          //         district: "पुरी ",
          //         state: " ओडिशा  ",
          //         img_url: [
          //           "./templeImg/Jagannatha/Jagannatha 1.jpg",
          //           "./templeImg/Jagannatha/Jagannatha 2.jpg",
          //         ],
          //         vid: "i_xYekU7Qqo",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 3,
          //         category: "dham",
          //         key: "bhadrinathtemple",
          //         title: "बद्रीनाथ मंदिर",
          //         desc: "बद्रीनाथ या बद्रीनारायण मंदिर भारत के उत्तराखंड में बद्रीनाथ शहर में स्थित भगवान विष्णु को समर्पित एक हिंदू मंदिर है। यहां भगवान विष्णु को बद्रीनाथ के रूप में पूजा जाता है। मंदिर भी भगवान विष्णु को समर्पित 108 दिव्य देशमों में से एक है।",
          //         district: "चमोली ",
          //         state: " उत्तराखंड ",
          //         img_url: [
          //           "./templeImg/Badrinath/Badrinath 1.jpg",
          //           "./templeImg/Badrinath/Badrinath 2.jpg",
          //         ],
          //         vid: "4xTpTOFYL-0",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //       {
          //         id: 4,
          //         category: "dham",
          //         key: "ramanathaswamytemple",
          //         title: "रामनाथस्वामी मंदिर",
          //         desc: "अरुलमिगु रामनाथस्वामी मंदिर तमिलनाडु के रामेश्वरम द्वीप पर स्थित है। यह ज्योतिर्लिंग होने के साथ ही चार धामों में से भी एक है। प्राचीन भारतीय शास्त्रों के अनुसार रावण पर विजय प्राप्त करने के लिए भगवान शिव का आशीर्वाद लेने के उद्देश्य से स्वयं भगवान राम ने इस ज्योतिर्लिंगम का निर्माण किया था। माना जाता है कि मंदिर के गर्भगृह में ऐसा ही एक लिंगम स्थापित है। भगवान राम ने जिस लिंगम की आराधना की थी वह रामनाथर के नाम से प्रसिद्ध है। ",
          //         district: "रामनाथापुरम ",
          //         state: "उत्तर प्रदेश ",
          //         img_url: [
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 1.jpg",
          //           "./templeImg/Ramanathaswamy/Ramanathaswamy 2.jpg",
          //         ],
          //         vid: "lanbHg9xRDc",
          //         cam1: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //         cam2: "https://www.youtube.com/watch?v=A5YdinFdV54&t=16s&ab_channel=TMVR",
          //       },
          //     ],
          //   },
          // ],
        },
      },
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
